define('views/blocks/CheckoutPaymentModeView',['underscore', 'backbone', 'jquery', 'router', 'app', 'SubView',
    'models/EdenredDataModel',
    'views/blocks/EdenredSwitchView',
    'views/blocks/checkout/PaymentModeSelectionView',
    'views/blocks/checkout/PaymentModeSelectionModalView',
    'views/blocks/paymentModeProviders/OgoneDirectIFrameView',
    'views/blocks/InvoiceAddressSelectorView',
    'template!blocks/checkout/payment-mode',
    'template!blocks/checkout/payment-mode-select',
    'template!blocks/checkout/restaurant-voucher',
], function (_, Backbone, $, router, app, SubView,
             EdenredDataModel,
             EdenredSwitchView,
             PaymentModeSelectionView,
             PaymentModeSelectionModalView,
             OgoneDirectIframeView,
             InvoiceAddressSelectorView,
             paymentModeTemplate,
             paymentModeSelectTemplate,
             restaurantVoucherTemplate
) {

    var checkoutModel,
        changedValue;

    var PROVIDER_REQUIRE_RETURN_MONEY = 1;
    var PROVIDER_REQUIRE_OGONE_ADD_CARD = 20;
    var PROVIDER_REQUIRE_OGONE_CVC = 21;
    var PROVIDE_REQUIRE_OGONE_DIRECT_IFRAME = 23;
    var PROVIDER_REQUIRE_PRIMARY_ADDRESS = 30;

    return Backbone.View.extend(SubView).extend({
        initialize: function (options) {
            checkoutModel = options.checkout;
            var view = this;
            view.subviews = [];
            view.listenTo(app.getCart(),'changeContext',view.reRender);
            view.listenTo(app,'paymentModeRequirement',view.onPaymentModeRequirement);
            view.listenTo(app,'CVCError',view.onCVCError);
            view.listenTo(app,'IframeOgoneDirect',view.onIframeOgoneDirect);
            view.render();
            checkoutModel.applyPreset();
        },

        render: function () {
            var view = this,
                subviewOptions = {checkoutModel:checkoutModel};
            if(checkoutModel.displayRestaurantVoucher()){
                view.appendView(EdenredSwitchView,'.payment-mode__selection--restaurant-voucher',subviewOptions);
            }
            view.appendView(PaymentModeSelectionView,'.payment-mode__selection.primary-mode',subviewOptions);
        },

        reRender: function () {
            var view = this;
            view.$el.html(paymentModeTemplate({checkout:checkoutModel}));
            view.render();
        },

        onPaymentModeRequirement:function(paymentMode,requirement) {
            this.displayRequirement(paymentMode,requirement);
        },

        displayRequirement:function(paymentMode,requirement){
            var autoSubmit = requirement === PROVIDE_REQUIRE_OGONE_DIRECT_IFRAME;
            switch(requirement){
                case PROVIDER_REQUIRE_PRIMARY_ADDRESS:
                    modalView = new InvoiceAddressSelectorView({});
                    break;
                default:
                var options = {
                    checkoutModel:checkoutModel,
                    paymentMode:paymentMode || false,
                    requirement:requirement,
                    autoSubmit:autoSubmit
                };
                var modalView = new PaymentModeSelectionModalView(options);
                break;
            }
            app.displayModal(modalView);
        },

        onCVCError:function(){
            this.displayRequirement(checkoutModel.getUsedPaymentMode(),PROVIDER_REQUIRE_OGONE_CVC);
        },

        onIframeOgoneDirect:function(data){
            var paymentMode = checkoutModel.getUsedPaymentMode();
            paymentMode.setOption('iframeOptions',data);
            this.displayRequirement(paymentMode,PROVIDE_REQUIRE_OGONE_DIRECT_IFRAME);
        }

    });


});
